import script from "./WelcomeAgeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeAgeModal.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeAgeModal.vue?vue&type=style&index=0&id=e85848b0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.45_vue@3.5.45_webpack@5.112.2_postcss@8.5.32_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e85848b0"]])

export default __exports__